import { IUser } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IColaboradorState {
    data: IUser;
    loading: boolean;
    error: string | null;
}

const initialState: IColaboradorState = {
    data: {} as IUser,
    loading: false,
    error: null
};

export const colaboradorSlice = createSlice({
    name: 'colaborador',
    initialState,
    reducers: {
        colaborador_fetching: (state) => {
            state.loading = true;
            state.data = {} as IUser;
            state.error = null;
        },
        colaborador_success: (state, action: PayloadAction<IUser>) => {
            state.error = null;
            state.loading = true;
            state.data = action.payload;
        },
        colaborador_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = true;
            state.data = {} as IUser;
        }
    }
});

export const { colaborador_fetching, colaborador_success, colaborador_error } = colaboradorSlice.actions;

export const selectorColaborador = (state: AppState) => state.colaborador;

export default colaboradorSlice.reducer;
